import { useQuery } from '@tanstack/react-query';
import { sagaMonitorApi } from '../api/sagaMonitorApi';

/**
 * GET /api/eraf/saga-monitor/instances/{id}/steps — 사가 단계 타임라인
 * queryKey: ['saga-monitor', 'steps', id]
 */
export function useSagaSteps(id: number | null) {
  return useQuery({
    queryKey: ['saga-monitor', 'steps', id],
    queryFn: () => sagaMonitorApi.getSteps(id!),
    enabled: id !== null,
    staleTime: 15_000,
  });
}
